<template>
  <div class="demo-chat-area" ref="cont">    
    <TransitionGroup name="list" tag="div" ref="list" class="message-list"> 
      <DemoChatItem
        v-for="message in messages"
        :key="message.lastMessageId"
        :message="message"
        v-on:messageMounted="scrollToNewest"
        ref="message"
      />
    </TransitionGroup>
  </div>
</template>

<script>
import DemoChatItem from './DemoChatItem'
export default {
  props: {
    messages: Array
  },
  watch: {
    // messageLen(n, o) {
    //   console.log(n, o)
    //   this.$nextTick(()=> {
    //     this.scrollToNewest()
    //   })
    // },
  },
  computed: {
    messageLen() {
      return this.messages.length
    }
  },
  mounted() {
    window.getScroll = ()=> {
      console.dir(this.$refs.cont.scrollTop, this.$refs.cont)
    }
  },
  methods: {
    scrollToNewest() {
      if (!this.$refs.cont) return
      console.log(">> Scroll To Bottom", (this.$refs.cont.scrollHeight - this.$refs.cont.clientHeight))
      this.$refs.cont.scrollTop = this.$refs.cont.scrollHeight + this.$refs.cont.clientHeight
      console.log("<< Scrolled To Bottom", this.$refs.cont.scrollTop)
      // this.$nextTick(()=> {
      // })
      // this.$refs.cont.scrollTo(0, this.$refs.cont.scrollHeight + 120)
    }
  },
  components: {
    DemoChatItem
  }
}
</script>


<style lang="scss" scoped>
.demo-chat-area {
  padding: 25px 0;
  position: relative;
  overflow: hidden;
  height: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
}

.message-list {
  position: relative;
}

// .list-enter-active,
// .list-leave-active {
//   transition: all 0.5s ease;
// }
// .list-enter-from,
// .list-leave-to {
//   opacity: 0;
//   transform: translate3d(0, 50%, 0);
// }
</style>